import { render, staticRenderFns } from "./indexWelcome.vue?vue&type=template&id=17cd65d0&scoped=true"
import script from "./indexWelcome.vue?vue&type=script&lang=js"
export * from "./indexWelcome.vue?vue&type=script&lang=js"
import style0 from "./indexWelcome.vue?vue&type=style&index=0&id=17cd65d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cd65d0",
  null
  
)

export default component.exports